import dateFormat from 'dateformat'

export function nowDatetime (format = 'yyyy-mm-dd') {
  // Data from : https://noob.tw/js-timezone/
  const taipeiTime = new Date().toLocaleString('en-US', { timeZone: 'Asia/Taipei' })
  return dateFormat(new Date(taipeiTime), format)
}
export function firstDayOfThisMonth () {
  // Data from : https://noob.tw/js-timezone/
  let taipeiTime = new Date().toLocaleString('en-US', { timeZone: 'Asia/Taipei' })
  taipeiTime = new Date(taipeiTime)
  const y = taipeiTime.getFullYear()
  const m = taipeiTime.getMonth()
  return dateFormat(new Date(y, m, 1), 'yyyy-mm-dd')
}

export function lastDayOfThisMonth () {
  // Data from : https://noob.tw/js-timezone/
  let taipeiTime = new Date().toLocaleString('en-US', { timeZone: 'Asia/Taipei' })
  taipeiTime = new Date(taipeiTime)
  const y = taipeiTime.getFullYear()
  const m = taipeiTime.getMonth()
  // https://www.w3resource.com/javascript-exercises/javascript-date-exercise-9.php
  const d = new Date(y, m + 1, 0).getDate()
  return dateFormat(new Date(y, m, d), 'yyyy-mm-dd')
}
